export function convertMetresToMiles(metres: number): number {
  return metres * 0.000621371192;
}
